import React from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Layout, Table, Button, Row, Col } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { getAllCompanies } from "services/company-service";
import { Header, TableSearch } from "components";
import Search from "antd/es/input/Search";

const { Footer, Content } = Layout;

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

const DataFetch = {
  data: [],
  loading: false,
};

const CompanyScreen = (props) => {
  const { login } = props;
  const navigate = useNavigate();
  const [data, setData] = React.useState(DataFetch);
  const [pageParams, setPageParams] = useSearchParams();
  const [page, setPage] = React.useState(pageParams.get("page") ?? 1);
  const [search, setSearch] = React.useState("");
  const load = async (filter = "") => {
    setData((x) => ({ ...x, loading: true }));
    const res = await getAllCompanies(filter);
    setData((x) => ({ data: res, loading: false }));
  };

  React.useEffect(() => {
    if (!login.company.master ||(pageParams.get("page") && !pageParams.get("search"))) {
      load();
    }
  }, []);
  React.useEffect(() => {
    setPageParams((p) => {
      p.set("page", page);
      return p;
    });
  }, [page]);
  return (
    <Layout className="alymente-layout">
      <Header title="Empresas" />
      <Content>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding:"16px"
          }}
        >
          <Row
            style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center' }}
            justify={"end"} gutter={[12, 12]}
          >
            <Col xl={8} lg={12} md={24}>
              <Search
                placeholder="Pesquise por nome ou cnpj"
                value={search}
                onChange={async (e) => {
                  setSearch(e.target.value);
                }}
                onPressEnter={async () => {
                  if(search.trim().length > 0) {
                    await load(search)
                  }
                }}
                onSearch={async () => {
                  if(search.trim().length > 0) {
                    await load(search)
                  }
                }}
              />
            </Col>
            <Col xl={3} lg={8} md={24}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={async () => {
                  setPageParams({ page: 1 });
                  setSearch("");
                  await load("");
                }}
              >
                Carregar Todos
              </Button>
            </Col>
          </Row>
          </div>
        <Table
          onChange={page => {
            setPage(page.current);
          }}
          scroll={{ y: 650, x: 1000 }}
          dataSource={data.data}
          loading={data.loading}
          pagination={{ current: page }}
          bordered
        >
          <Table.Column align={"left"} title="Nome" dataIndex="name" key="name" />
          <Table.Column
            align={"left"}
            title="Razão Social"
            dataIndex="corporateName"
            key="corporateName"
          />
          <Table.Column
            width={200}
            align={"center"}
            title="Tipo"
            dataIndex={["companyType", "name"]}
            key="companyType.name"
          />
          <Table.Column width={200} align={"center"} title="CNPJ" dataIndex="cnpj" key="cnpj" />
          <Table.Column
            fixed="right"
            width={100}
            align={"center"}
            title="Ações"
            dataIndex="id"
            key="id"
            render={value => (
              <Button size="small" type={"link"} onClick={() => navigate(`/company/${value}`)}>
                Editar
              </Button>
            )}
          />
        </Table>
      </Content>
      <Footer>
        <Button
          className="btn-save"
          type="primary"
          icon={<PlusCircleOutlined />}
          onClick={() => navigate(`/company/add`)}
        >
          Nova Empresa
        </Button>
      </Footer>
    </Layout>
  );
};

export default connect(mapStateToProps, {})(CompanyScreen);
